module.exports = __webpack_public_path__ + "img/OM.c9689808.png";